'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$URL$$anon$143(url$2, outer) {
  this.ceg = null;
  this.ceg = url$2;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$URL$$anon$143 as $c_Lpresto_types$URL$$anon$143 };
$p = $c_Lpresto_types$URL$$anon$143.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$URL$$anon$143;
/** @constructor */
function $h_Lpresto_types$URL$$anon$143() {
}
export { $h_Lpresto_types$URL$$anon$143 as $h_Lpresto_types$URL$$anon$143 };
$h_Lpresto_types$URL$$anon$143.prototype = $p;
$p.nG = (function(seq) {
  return seq.b0(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$32) => _$32.xM.hw(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$33) => {
    var this$2 = _$33.n8;
    var this$4 = this$2.toLowerCase();
    var this$3 = this.ceg;
    var s = this$3.toLowerCase();
    return ((this$4.indexOf(s) | 0) !== (-1));
  }))))));
});
var $d_Lpresto_types$URL$$anon$143 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$URL$$anon$143, "presto.types$URL$$anon$143", ({
  a2K: 1,
  bM: 1
}));
export { $d_Lpresto_types$URL$$anon$143 as $d_Lpresto_types$URL$$anon$143 };
//# sourceMappingURL=presto.types$-U-R-L$$anon$143.js.map
